var Watcher = function(query) {
  var mediaQuery = window.matchMedia('(min-width:' + query.breakpoint + 'px)'),
  watch = function(mediaQuery) {    
    if (mediaQuery.matches) {
      query.match();
    } else {
      query.dismatch();
    }
  }
  
  mediaQuery.addListener(watch);
  watch(mediaQuery);

};

export default Watcher;


// WEBPACK FOOTER //
// ./prod/layout/js/modules/watcher.js